/**
 * Module messages — généré depuis le plan directeur GÉCÉRAM CRM (2026-07-28).
 * S'intègre par le registre : aucun fichier du noyau modifié.
 */
import { lazy } from "react";
import type { ModuleDef } from "../../core/module-contract";

const mod: ModuleDef = {
  id: "messages",
  label: "WhatsApp",
  icon: "i-chat",
  navGroup: "communications",
  navOrder: 20,
  rolesRequis: [],
  routes: [{ path: "/messages", component: lazy(() => import("./routes/Index")) }],
};

export default mod;
